import {
	Form,
	Row,
	Col,
	Button,
	Divider,
	ColProps,
	InputProps,
	DatePickerProps,
	RateProps,
	SelectProps,
	UploadProps,
	CheckboxProps,
	Tooltip
} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {Question, Trash} from 'phosphor-react';
import CaseInput from '../CaseInput';
import {FormInstance} from 'antd/lib/form';
import moment from 'moment';
import {TextAreaProps} from 'antd/lib/input';
import './styles.less';

type ArrayLengthMutationKeys = 'splice' | 'push' | 'pop' | 'shift' | 'unshift' | number;
type ArrayItems<T extends Array<any>> = T extends Array<infer TItems> ? TItems : never;
export type FixedLengthArray<T extends any[]> = Pick<T, Exclude<keyof T, ArrayLengthMutationKeys>> & {
	[Symbol.iterator]: () => IterableIterator<ArrayItems<T>>;
};

type dictStringTypes =
	| 'candidateMilitaryService'
	| 'classrooms'
	| 'candidateUniversityExpectationRatings'
	| 'candidateUniversityExpectations'
	| 'candidateUniversityInfo'
	| 'candidateFileTypes'
	| 'candidateAdmissionPreparation'
	| 'candidateStatus'
	| 'userType'
	| 'genderTypes'
	| 'countries'
	| 'subjects'
	| 'faculties'
	| 'paymentTypes'
	| 'admissionNotificationTypes'
	| 'admissionNotificationEvents'
	| 'admissionDistributionTypes'
	| 'candidateAdmissionRejectionReasons'
	| 'admissionAppealStatuses'
	| 'admissionExamStatuses'
	| 'regions'
	| 'cities'
	| 'tables'
	| 'appealsDistributionTypes'
	| 'optionalSubjects'
	| 'candidateAdmissionSubjects'
	| 'courses'
	| 'flows'
	| 'semesters'
	| 'studentSpecializations'
	| 'lecturerDiplomaTypes'
	| 'academicLevelTypes'
	| 'lecturerSections'
	| 'lecturerEmploymentTypes'
	| 'lecturerAmbions'
	| 'lecturerFileTypes'
	| 'lecturerContractTypes'
	| 'documentStatus'
	| 'workerTypes'
	| 'lecturerVacationTypes'
	| 'studentStatuses'
	| 'studentFileTypes'
	| 'applicationTypes'
	| 'applicationStatuses'
	| 'paymentPurposes'
	| 'educationTypes'
	| 'userStatus'
	| 'studentAdmissionTypes'
	| 'commandCategory'
	| 'commandType'
	| 'curriculumAcademicYears'
	| 'examLanguagePassTypes'
	| 'curriculumGroupTypes'
	| 'curriculumLessonTypes'
	| 'curriculumSubjectTypes'
	| 'lecturers';

export interface ModalFormFieldTypes {
	name?: string;
	label?: string;
	type: string;
	className?: string;
	rules?: any;
	isRequired?: boolean | ((depValue: any) => boolean);
	isDisabled?: (value: any) => boolean; // only for not formGroup
	isRequiredDep?: string;
	depFieldKey?: string | string[];
	depValue?:
		| string
		| number
		| boolean
		| (string | number | boolean | ((depValue: any) => boolean))[]
		| ((depValue: any) => boolean);
	depKey?: string;
	fetchByIdKey?: string;
	fetchOnDepValue?: boolean | string;
	inputProps?: InputProps;
	textAreaProps?: TextAreaProps;
	checkboxProps?: CheckboxProps;
	checkboxGroupProps?: any;
	datePickerProps?: DatePickerProps | any;
	rangePickerProps?: any;
	selectProps?: SelectProps | any;
	hiddenOptions?: (string | number)[];
	uploadProps?: UploadProps;
	rateProps?: RateProps;
	radioProps?: any;
	dictionaryApiPath?: dictStringTypes;
	disabledOnDep?: boolean;
	tooltip?: (data: any, label?: string) => any;
	customApiFetch?: {
		path: string;
		labelKey: string | ((val: any) => string);
		valueKey: string;
	};
	colProps?: ColProps;
	inputs?: ModalFormFieldTypes[];
	formItemProps?: FormItemProps;
	disableDynamicActions?: boolean;
	disableDivider?: boolean;
	visibility?: FixedLengthArray<['ADD' | 'EDIT' | 'VIEW', ('ADD' | 'EDIT' | 'VIEW')?]>;
	disabledAt?: FixedLengthArray<['ADD' | 'EDIT' | 'VIEW', ('ADD' | 'EDIT' | 'VIEW')?]>;
	groupTitle?: string;
	minimalItem?: number;
	disableSearch?: boolean;
	component?: (
		arg?: any,
		selectedRowId?: number,
		disabled?: boolean,
		visible?: 'ADD' | 'EDIT' | 'VIEW'
	) => React.ReactNode;
	editableFile?: boolean;
	onlyArmenian?: boolean;
	minimaltem?: number;
	minReqItem?: number;
}

const defaultColProps = {
	xs: 24,
	lg: 8
};

const required = [{required: true}];
const armenian = [
	{pattern: new RegExp('^[Ա-Ֆա-ֆ-և0-9/-<․.,""?՛!\'\\\\> ]{1,9999}$'), message: 'Միայն հայատառ մուտք'}
];

interface FormTitleTypes {
	label?: string;
	colProps: ColProps;
}

function calcFieldRules(isRequired?: boolean, onlyArmenian?: boolean, rules?: any) {
	const newRules = isRequired === false ? rules || [] : [...(rules || []), ...required];
	if (onlyArmenian) {
		newRules.push(...armenian);
	}

	return newRules;
}

export function ltrim(str: any) {
	if (!str) return str;
	return str.replace(/^\s+/g, '');
}

const FormTitle = ({label, colProps}: FormTitleTypes) => {
	return (
		<Col {...colProps}>
			<div className="form-group-title">{label}</div>
		</Col>
	);
};

interface FormItemProps {
	name?: string | (string | number)[];
	field: ModalFormFieldTypes;
	formErrors: any;
	parentName?: string;
	index?: number;
	disabled?: boolean;
	dynemicLabel?: string;
	hidden?: boolean;
	getValueFromEvent?: (val: any) => any;
	noStyle?: boolean;
}

const FormItem = ({
	name,
	field,
	formErrors,
	parentName,
	index = 0,
	disabled,
	dynemicLabel
}: FormItemProps) => {
	if (field.type === 'divider') {
		return (
			<Col xs={24}>
				<Divider style={{margin: '0 0 15px'}} />
			</Col>
		);
	}

	if (field.type === 'title') {
		return <FormTitle label={field.label} colProps={{xs: 24}} />;
	}

	if (field.type === 'newLine') {
		return <Col xs={24} />;
	}

	const {
		depFieldKey,
		depValue,
		depKey,
		fetchOnDepValue,
		colProps = defaultColProps,
		formItemProps,
		isRequired,
		onlyArmenian,
		isRequiredDep,
		label = ' ',
		disabledAt,
		tooltip,
		...props
	} = field;

	let newFormItems = formItemProps || {};

	if (field.type === 'text') {
		newFormItems = {
			...newFormItems,
			getValueFromEvent: (val: any) => ltrim(val.target.value)
		};
	} else if (field.type === 'file') {
		newFormItems = {
			...newFormItems,
			getValueFromEvent: (val: any) =>
				typeof val === 'string' ? val : val.fileList.length ? val.file : undefined
		};
	} else if (field.type === 'date') {
		newFormItems = {
			...newFormItems,
			getValueFromEvent: (val: any) => {
				if (!val) return;

				if (props.datePickerProps?.format === 'YYYY') {
					return moment(val).format('YYYY');
				} else if (props.datePickerProps?.format === 'HH:mm') {
					return moment(val, 'HH:mm').format('HH:mm');
				} else if (props.datePickerProps?.format === 'DD-MM-YYYY HH:mm') {
					return moment(val).format('YYYY-MM-DD HH:mm');
				} else {
					return moment(val).format('YYYY-MM-DD');
				}
			}
		};
	}

	const newLabel = (() => {
		if (!tooltip) return dynemicLabel || label;

		return (
			<div style={{display: 'flex', alignItems: 'center'}}>
				<span>{dynemicLabel || label}</span>
				<Tooltip title={tooltip} placement="bottom">
					<Question size={16} weight="fill" style={{marginLeft: 5}} />
				</Tooltip>
			</div>
		);
	})();

	const helpStatus =
		name &&
		(Array.isArray(name)
			? parentName &&
			  formErrors[parentName] &&
			  formErrors[parentName][name[0]] &&
			  formErrors[parentName][name[0]][name[1]]
			: formErrors[name as string]);

	if (field.type === 'customElement' && !depFieldKey) {
		return <Col {...colProps}>{field.component && field.component()}</Col>;
	}

	return depFieldKey ? (
		<Form.Item
			noStyle
			className={field?.className}
			shouldUpdate={(prevValues, currentValues) => {
				const depFieldKeyArr = Array.isArray(depFieldKey) ? depFieldKey : [depFieldKey];

				let update = false;
				if (parentName) {
					depFieldKeyArr.forEach(key => {
						if (
							(prevValues[parentName][index] && prevValues[parentName][index][key]) !==
							(currentValues[parentName][index] && currentValues[parentName][index][key])
						) {
							update = true;
						}
					});
				} else {
					depFieldKeyArr.forEach(key => {
						if (prevValues[key] !== currentValues[key]) update = true;
					});
				}

				return update;
			}}>
			{({getFieldValue}: FormInstance) => {
				let showField = false;
				let isFieldRequired = isRequired;
				let dependencies = undefined;
				let depFieldValue = '';

				if (Array.isArray(depFieldKey)) {
					const depStatus = depFieldKey.every((key, i) => {
						const fieldValue = parentName
							? getFieldValue([parentName, index, key])
							: getFieldValue(key);

						if (
							typeof isRequired === 'function' &&
							!Array.isArray(isRequiredDep) &&
							isRequiredDep === key
						) {
							isFieldRequired = isRequired(fieldValue);
							dependencies = parentName ? [[parentName, index, key]] : [key];
						}

						if (typeof isRequired === 'function' && Array.isArray(isRequiredDep)) {
							const obj: any = {};
							isRequiredDep.forEach(i => {
								if (Array.isArray(i)) {
									if (parentName) obj[i[0]] = getFieldValue([parentName, index, i[0]]);
								} else {
									obj[i] = getFieldValue(i);
								}
							});
							isFieldRequired = isRequired(obj);
							dependencies = parentName ? [[parentName, index, key]] : [key];
						}

						return (
							fieldValue === (Array.isArray(depValue) && depValue[i]) ||
							(Array.isArray(depValue) &&
								typeof depValue[i] === 'function' &&
								(depValue[i] as Function)(fieldValue)) ||
							(Array.isArray(fieldValue) &&
								fieldValue.some(
									(val: any) => val === (Array.isArray(depValue) && depValue[i])
								))
						);
					});

					if (depStatus) showField = true;
				} else {
					const fieldValue = parentName
						? getFieldValue([parentName, index, depFieldKey])
						: getFieldValue(depFieldKey);

					if (fetchOnDepValue && fieldValue) {
						depFieldValue = fieldValue;
					}

					if (typeof isRequired === 'function') {
						isFieldRequired = isRequired(fieldValue);
						dependencies = parentName ? [[parentName, index, depFieldKey]] : [depFieldKey];
					}

					if (
						(fetchOnDepValue && fieldValue && fieldValue?.length !== 0) ||
						(typeof depValue === 'function' && depValue(fieldValue)) ||
						fieldValue === depValue ||
						(Array.isArray(fieldValue) && fieldValue.some((val: any) => val === depValue))
					) {
						showField = true;
					}
				}

				const selectAditionalProp = field.type === 'select' ? {fetchId: depFieldValue} : {};

				return showField ? (
					<Col {...colProps}>
						<Form.Item
							label={newLabel}
							name={name}
							rules={calcFieldRules(isFieldRequired as boolean, onlyArmenian, field.rules)}
							help={helpStatus}
							validateStatus={!!helpStatus ? 'error' : undefined}
							dependencies={dependencies}
							{...newFormItems}>
							<CaseInput disabled={disabled} {...props} {...selectAditionalProp} />
						</Form.Item>
					</Col>
				) : null;
			}}
		</Form.Item>
	) : (
		<Col {...colProps}>
			<Form.Item
				label={newLabel}
				name={name}
				rules={calcFieldRules(isRequired as boolean, onlyArmenian, field.rules)}
				help={helpStatus}
				validateStatus={!!helpStatus ? 'error' : undefined}
				{...newFormItems}>
				<CaseInput disabled={disabled} {...props} />
			</Form.Item>
		</Col>
	);
};

const FormGroup = ({
	tabFields,
	formErrors,
	visible,
	formInitialValues
}: {
	tabFields: ModalFormFieldTypes[];
	formErrors: any;
	visible?: 'ADD' | 'EDIT' | 'VIEW';
	formInitialValues?: any;
	selectedRowId?: number;
	form?: FormInstance;
	formItemCustomInfo?: any;
}) => {
	return (
		<Row gutter={16}>
			{tabFields.map((field, i) => {
				const {
					name,
					colProps = defaultColProps,
					visibility = ['ADD', 'EDIT'],
					groupTitle,
					minimaltem = 0,
					disabledAt,
					disableDynamicActions,
					disableDivider,
					minReqItem
				} = field;

				if (visible && !visibility.includes(visible)) return null;
				if (field.type === 'formGroup') {
					return (
						<Form.List key={i} name={name as string}>
							{(fields, {add, remove}) => (
								<>
									{fields.map(({key, name: fieldName}, index) => {
										const newLabel = formInitialValues
											? (formInitialValues[name as string] &&
													formInitialValues[name as string][index]?.label) ||
											  formInitialValues[name as string][index]?.name
											: '';

										return (
											<Col key={key} {...colProps}>
												<Row gutter={16} align="middle">
													{!!groupTitle && (
														<FormTitle
															label={groupTitle + ' ' + (index + 1)}
															colProps={{xs: 18}}
														/>
													)}

													{!disableDynamicActions && minimaltem <= index && (
														<Col xs={6} style={{textAlign: 'right'}}>
															<Button
																className="form-group-delete"
																onClick={() => remove(fieldName)}
																icon={<Trash size={18} weight="fill" />}
															/>
														</Col>
													)}
												</Row>
												<Row gutter={16} align="middle">
													{field.inputs?.map(
														(input: ModalFormFieldTypes, i: number) => {
															const {visibility = ['ADD', 'EDIT']} = input;
															if (visible && !visibility?.includes(visible))
																return null;
															return (
																<FormItem
																	key={i}
																	name={[fieldName, input.name as string]}
																	field={(() => {
																		return minReqItem &&
																			field?.inputs?.length
																			? {
																					...input,
																					isRequired:
																						input.isRequired
																			  }
																			: input;
																	})()}
																	formErrors={formErrors}
																	parentName={name}
																	index={index}
																	dynemicLabel={newLabel}
																	disabled={
																		!!(
																			visible &&
																			disabledAt?.length &&
																			disabledAt.includes(visible)
																		)
																	}
																/>
															);
														}
													)}
												</Row>
												{!disableDivider && index !== fields.length - 1 && (
													<Row gutter={16} align="middle">
														<Col xs={24}>
															<Divider style={{margin: '0 0 15px'}} />
														</Col>
													</Row>
												)}
											</Col>
										);
									})}
									{!disableDynamicActions && (
										<Col xs={24}>
											<Form.Item>
												<Button
													type="dashed"
													onClick={() => add()}
													block
													icon={<PlusOutlined />}>
													{field.label}
												</Button>
											</Form.Item>
										</Col>
									)}
								</>
							)}
						</Form.List>
					);
				}

				return (
					<FormItem
						key={i}
						name={name}
						field={field}
						formErrors={formErrors}
						disabled={!!(visible && disabledAt?.length && disabledAt.includes(visible))}
					/>
				);
			})}
		</Row>
	);
};

export default FormGroup;
